"use client"
const sampleProjects = [
  /*{
    id: "263",
    name: "REDONDA POSES",
    category: "Simulador",
    thumbnail: "/models/novos/poses/poster.webp",
    createdAt: "10-06-2025",
    path: "poses/3",
    custom: false,
    wiggle: false
  },*/
  {
    id: "1",
    name: "BASICA",
    category: "Simulador",
    thumbnail: "/models/novos/BASICA.webp",
    createdAt: "10-06-2025",
    path: "BASICA",
    custom: false,
    model_id: null,
    wiggle: true
  },
  {
    id: "2",
    name: "BASICA MANGA LONGA",
    category: "Simulador",
    thumbnail: "/models/novos/BASICA_MANGA_LONGA.webp",
    createdAt: "10-06-2025",
    path: "BASICA_MANGA_LONGA",
    custom: false,
    wiggle: true
  },
  {
    id: "3",
    name: "BASICA V",
    category: "Simulador",
    thumbnail: "/models/novos/BASICA_V.webp",
    createdAt: "10-06-2025",
    path: "BASICA_V",
    custom: false,
    wiggle: true
  },
  {
    id: "4",
    name: "BASICA V MANGA LONGA",
    category: "Simulador",
    thumbnail: "/models/novos/BASICA_V_MANGA_LONGA.webp",
    createdAt: "10-06-2025",
    path: "BASICA_V_MANGA_LONGA",
    custom: false,
    wiggle: true
  },
  {
    id: "5",
    name: "RAGLÃ",
    category: "Simulador",
    thumbnail: "/models/novos/RAGLA.webp",
    createdAt: "10-06-2025",
    path: "RAGLA",
    custom: false,
    wiggle: true
  },
  {
    id: "6",
    name: "RAGLÃ MANGA LONGA",
    category: "Simulador",
    thumbnail: "/models/novos/RAGLA_MANGA_LONGA.webp",
    createdAt: "10-06-2025",
    path: "RAGLA_MANGA_LONGA",
    custom: false,
    wiggle: true
  },
  {
    id: "7",
    name: "RAGLÃ V",
    category: "Simulador",
    thumbnail: "/models/novos/RAGLA_V.webp",
    createdAt: "10-06-2025",
    path: "RAGLA_V",
    custom: false,
    wiggle: true
  },
  {
    id: "8",
    name: "RAGLÃ V ML",
    category: "Simulador",
    thumbnail: "/models/novos/RAGLA_V_ML.webp",
    createdAt: "10-06-2025",
    path: "RAGLA_V_ML",
    custom: false,
    wiggle: true
  },
  {
    id: "9",
    name: "RAGLÃ RETA U",
    category: "Simulador",
    thumbnail: "/models/novos/RAGLA_RETA_U.webp",
    createdAt: "10-06-2025",
    path: "RAGLA_RETA_U",
    custom: false,
    wiggle: true
  },
  {
    id: "10",
    name: "RAGLÃ RETA V",
    category: "Simulador",
    thumbnail: "/models/novos/RAGLA_RETA_V.webp",
    createdAt: "10-06-2025",
    path: "RAGLA_RETA_V",
    custom: false,
    wiggle: true
  },
  {
    id: "11",
    name: "REGATA BASQ COM LAT",
    category: "Simulador",
    thumbnail: "/models/novos/REGATA_BASQ_COM_LAT.webp",
    createdAt: "10-06-2025",
    path: "REGATA_BASQ_COM_LAT",
    custom: false,
    wiggle: true
  },
  {
    id: "12",
    name: "REGATA MACHÃO",
    category: "Simulador",
    thumbnail: "/models/novos/REGATA_MACHAO.webp",
    createdAt: "10-06-2025",
    path: "REGATA_MACHAO",
    custom: false,
    wiggle: true
  },
  {
    id: "13",
    name: "REGATA CAVADONA",
    category: "Simulador",
    thumbnail: "/models/novos/REGATA_CAVADONA.webp",
    createdAt: "10-06-2025",
    path: "REGATA_CAVADONA",
    custom: false,
    wiggle: true
  },
  {
    id: "14",
    name: "REGATA COM LATERAL",
    category: "Simulador",
    thumbnail: "/models/novos/REGATA_COM_LATERAL.webp",
    createdAt: "10-06-2025",
    path: "REGATA_COM_LATERAL",
    custom: false,
    wiggle: true
  },
  {
    id: "15",
    name: "COLETE",
    category: "Simulador",
    thumbnail: "/models/novos/COLETE.webp",
    createdAt: "10-06-2025",
    path: "COLETE",
    custom: false,
    wiggle: true
  },
  {
    id: "16",
    name: "POLO MASCULINA",
    category: "Simulador",
    thumbnail: "/models/novos/POLO_MASCULINA.webp",
    createdAt: "10-06-2025",
    path: "POLO_MASCULINA",
    custom: false,
    wiggle: true
  },
  {
    id: "17",
    name: "Animado Masculino 1",
    category: "Animados_M",
    thumbnail: "/models/novos/Animado_M_1.webp",
    createdAt: "10-06-2025",
    path: "Animado_M_1",
    custom: false,
  },
  {
    id: "18",
    name: "Animado Masculino 2",
    category: "Animados_M",
    thumbnail: "/models/novos/Animado_M_2.webp",
    createdAt: "10-06-2025",
    path: "Animado_M_2",
    custom: false,
  },
  {
    id: "19",
    name: "Animado Masculino 3",
    category: "Animados_M",
    thumbnail: "/models/novos/Animado_M_3.webp",
    createdAt: "10-06-2025",
    path: "Animado_M_3",
    custom: false,
  },
  {
    id: "20",
    name: "Animado Masculino 4",
    category: "Animados_M",
    thumbnail: "/models/novos/Animado_M_4.webp",
    createdAt: "10-06-2025",
    path: "Animado_M_4",
    custom: false,
  },
  {
    id: "21",
    name: "Animado Masculino 5",
    category: "Animados_M",
    thumbnail: "/models/novos/155.webp",
    createdAt: "10-06-2025",
    path: "155",
    custom: false,
  },
  {
    id: "22",
    name: "Animado Masculino 6",
    category: "Animados_M",
    thumbnail: "/models/novos/156.webp",
    createdAt: "10-06-2025",
    path: "156",
    custom: false,
  },
  {
    id: "23",
    name: "Animado Masculino 7",
    category: "Animados_M",
    thumbnail: "/models/novos/157.webp",
    createdAt: "10-06-2025",
    path: "157",
    custom: false,
  },
  {
    id: "24",
    name: "Animado Masculino 8",
    category: "Animados_M",
    thumbnail: "/models/novos/158.webp",
    createdAt: "10-06-2025",
    path: "158",
    custom: false,
  },
  {
    id: "25",
    name: "Animado Masculino 9",
    category: "Animados_M",
    thumbnail: "/models/novos/159.webp",
    createdAt: "10-06-2025",
    path: "159",
    custom: false,
  },
  {
    id: "26",
    name: "Animado Masculino 10",
    category: "Animados_M",
    thumbnail: "/models/novos/160.webp",
    createdAt: "10-06-2025",
    path: "160",
    custom: false,
  },
  {
    id: "27",
    name: "Animado Masculino 11",
    category: "Animados_M",
    thumbnail: "/models/novos/161.webp",
    createdAt: "10-06-2025",
    path: "161",
    custom: false,
  },
  {
    id: "28",
    name: "Animado Masculino 12",
    category: "Animados_M",
    thumbnail: "/models/novos/162.webp",
    createdAt: "10-06-2025",
    path: "162",
    custom: false,
  },
  {
    id: "29",
    name: "Animado Masculino 13",
    category: "Animados_M",
    thumbnail: "/models/novos/163.webp",
    createdAt: "10-06-2025",
    path: "163",
    custom: false,
  },
  {
    id: "30",
    name: "Animado Masculino 14",
    category: "Animados_M",
    thumbnail: "/models/novos/164.webp",
    createdAt: "10-06-2025",
    path: "164",
    custom: false,
  },
  {
    id: "31",
    name: "Animado Feminino 1",
    category: "Animados_F",
    thumbnail: "/models/novos/166.webp",
    createdAt: "10-06-2025",
    path: "166",
    custom: false,
  },
  {
    id: "32",
    name: "Animado Feminino 2",
    category: "Animados_F",
    thumbnail: "/models/novos/167.webp",
    createdAt: "10-06-2025",
    path: "167",
    custom: false,
  },
  {
    id: "33",
    name: "Animado Feminino 3",
    category: "Animados_F",
    thumbnail: "/models/novos/168.webp",
    createdAt: "10-06-2025",
    path: "168",
    custom: false,
  },
  {
    id: "34",
    name: "Animado Feminino 4",
    category: "Animados_F",
    thumbnail: "/models/novos/169.webp",
    createdAt: "10-06-2025",
    path: "169",
    custom: false,
  },
  {
    id: "35",
    name: "Animado Feminino 5",
    category: "Animados_F",
    thumbnail: "/models/novos/170.webp",
    createdAt: "10-06-2025",
    path: "170",
    custom: false,
  },
  {
    id: "36",
    name: "Animado Feminino 6",
    category: "Animados_F",
    thumbnail: "/models/novos/171.webp",
    createdAt: "10-06-2025",
    path: "171",
    custom: false,
  },
  {
    id: "37",
    name: "Animado Feminino 7",
    category: "Animados_F",
    thumbnail: "/models/novos/172.webp",
    createdAt: "10-06-2025",
    path: "172",
    custom: false,
  },
  {
    id: "38",
    name: "Animado Feminino 8",
    category: "Animados_F",
    thumbnail: "/models/novos/173.webp",
    createdAt: "10-06-2025",
    path: "173",
    custom: false,
  },
  {
    id: "39",
    name: "Animado Feminino 9",
    category: "Animados_F",
    thumbnail: "/models/novos/174.webp",
    createdAt: "10-06-2025",
    path: "174",
    custom: false,
  },
  {
    id: "40",
    name: "Animado Feminino 10",
    category: "Animados_F",
    thumbnail: "/models/novos/175.webp",
    createdAt: "10-06-2025",
    path: "175",
    custom: false,
  },
  {
    id: "41",
    name: "Animado Feminino 11",
    category: "Animados_F",
    thumbnail: "/models/novos/176.webp",
    createdAt: "10-06-2025",
    path: "176",
    custom: false,
  },
  {
    id: "42",
    name: "Animado Feminino 12",
    category: "Animados_F",
    thumbnail: "/models/novos/177.webp",
    createdAt: "10-06-2025",
    path: "177",
    custom: false,
  },
  {
    id: "43",
    name: "Animado Feminino 13",
    category: "Animados_F",
    thumbnail: "/models/novos/178.webp",
    createdAt: "10-06-2025",
    path: "178",
    custom: false,
  },
  {
    id: "44",
    name: "Animado Feminino 14",
    category: "Animados_F",
    thumbnail: "/models/novos/179.webp",
    createdAt: "10-06-2025",
    path: "179",
    custom: false,
  },
  {
    id: "45",
    name: "Boné",
    category: "Boné",
    thumbnail: "/models/novos/7.webp",
    createdAt: "10-06-2025",
    path: "7",
    custom: false,
  },
  {
    id: "46",
    name: "Banner 1",
    category: "Banner",
    thumbnail: "/models/novos/9.webp",
    createdAt: "10-06-2025",
    path: "9",
    custom: false,
  },
  {
    id: "47",
    name: "Banner 2",
    category: "Banner",
    thumbnail: "/models/novos/10.webp",
    createdAt: "10-06-2025",
    path: "10",
    custom: false,
  },
  {
    id: "48",
    name: "Banner 3",
    category: "Banner",
    thumbnail: "/models/novos/11.webp",
    createdAt: "10-06-2025",
    path: "11",
    custom: false,
  },
  {
    id: "49",
    name: "Banner 4",
    category: "Banner",
    thumbnail: "/models/novos/12.webp",
    createdAt: "10-06-2025",
    path: "12",
    custom: false,
  },
  {
    id: "50",
    name: "Banner 5",
    category: "Banner",
    thumbnail: "/models/novos/144.webp",
    createdAt: "10-06-2025",
    path: "144",
    custom: false,
  },
  {
    id: "51",
    name: "Banner 6",
    category: "Banner",
    thumbnail: "/models/novos/145.webp",
    createdAt: "10-06-2025",
    path: "145",
    custom: false,
  },
  {
    id: "52",
    name: "Banner 7",
    category: "Banner",
    thumbnail: "/models/novos/146.webp",
    createdAt: "10-06-2025",
    path: "146",
    custom: false,
  },
  {
    id: "53",
    name: "ABC",
    category: "Simulador",
    thumbnail: "/models/novos/abc.webp",
    createdAt: "21-06-2025",
    path: "abc",
    custom: false,
  },
  {
    id: "54",
    name: "CAETE",
    category: "Simulador",
    thumbnail: "/models/novos/CAETE.webp",
    createdAt: "21-06-2025",
    path: "CAETE",
    custom: false,
  },
  {
    id: "55",
    name: "CAETE JUDÔ",
    category: "Simulador",
    thumbnail: "/models/novos/CAETE_JUDO.webp",
    createdAt: "21-06-2025",
    path: "CAETE_JUDO",
    custom: false,
  },
  {
    id: "56",
    name: "PAYSSANDU",
    category: "Simulador",
    thumbnail: "/models/novos/PAYSSANDU.webp",
    createdAt: "21-06-2025",
    path: "PAYSSANDU",
    custom: false,
  },
  {
    id: "57",
    name: "REMO",
    category: "Simulador",
    thumbnail: "/models/novos/REMO.webp",
    createdAt: "21-06-2025",
    path: "REMO",
    custom: false,
  },
  {
    id: "58",
    name: "142",
    category: "Simulador",
    thumbnail: "/models/novos/142.webp",
    createdAt: "14-07-2025",
    path: "142",
    custom: false,
  },
  {
    id: "59",
    name: "143",
    category: "Simulador",
    thumbnail: "/models/novos/143.webp",
    createdAt: "14-07-2025",
    path: "143",
    custom: false,
  },
  {
    id: "60",
    name: "4",
    category: "Simulador",
    thumbnail: "/models/novos/4.webp",
    createdAt: "14-07-2025",
    path: "4",
    custom: false,
  },
  {
    id: "61",
    name: "13",
    category: "Simulador",
    thumbnail: "/models/novos/13.webp",
    createdAt: "14-07-2025",
    path: "13",
    custom: false,
  },
  {
    id: "62",
    name: "14",
    category: "Simulador",
    thumbnail: "/models/novos/14.webp",
    createdAt: "14-07-2025",
    path: "14",
    custom: false,
  },
  {
    id: "63",
    name: "89",
    category: "Simulador",
    thumbnail: "/models/novos/89.webp",
    createdAt: "14-07-2025",
    path: "89",
    custom: false,
  },
  {
    id: "64",
    name: "90",
    category: "Simulador",
    thumbnail: "/models/novos/90.webp",
    createdAt: "14-07-2025",
    path: "90",
    custom: false,
  },
  {
    id: "65",
    name: "91",
    category: "Simulador",
    thumbnail: "/models/novos/91.webp",
    createdAt: "14-07-2025",
    path: "91",
    custom: false,
  },
  {
    id: "66",
    name: "92",
    category: "Simulador",
    thumbnail: "/models/novos/92.webp",
    createdAt: "14-07-2025",
    path: "92",
    custom: false,
  },
  {
    id: "67",
    name: "CORTAVENTO",
    category: "Novos",
    thumbnail: "/models/novos/CORTAVENTO.webp",
    createdAt: "28-07-2025",
    path: "CORTAVENTO",
    custom: false,
  },
  {
    id: "68",
    name: "JAQUETA TOUCA",
    category: "Novos",
    thumbnail: "/models/novos/JAQUETATOUCA.webp",
    createdAt: "28-07-2025",
    path: "JAQUETATOUCA",
    custom: false,
  },
  {
    id: "69",
    name: "JAQUETA GOLA ALTA",
    category: "Novos",
    thumbnail: "/models/novos/JAQUETAGOLAALTA.webp",
    createdAt: "28-07-2025",
    path: "JAQUETAGOLAALTA",
    custom: false,
  },
  {
    id: "70",
    name: "JAQUETA GOLA BAIXA",
    category: "Novos",
    thumbnail: "/models/novos/JAQUETAGOLABAIXA.webp",
    createdAt: "28-07-2025",
    path: "JAQUETAGOLABAIXA",
    custom: false,
  },
  {
    id: "71",
    name: "PESCA",
    category: "Novos",
    thumbnail: "/models/novos/PESCA.webp",
    createdAt: "28-07-2025",
    path: "PESCA",
    custom: false,
  },
  {
    id: "72",
    name: "POLO",
    category: "Novos",
    thumbnail: "/models/novos/POLO.webp",
    createdAt: "28-07-2025",
    path: "POLO",
    custom: false,
  },
  {
    id: "73",
    name: "RAGLÃ V",
    category: "Novos",
    thumbnail: "/models/novos/RAGLAV.webp",
    createdAt: "28-07-2025",
    path: "RAGLAV",
    custom: false,
  },
  {
    id: "74",
    name: "Polo",
    category: "Novos",
    thumbnail: "/models/novos/polo2.webp",
    createdAt: "29-08-2025",
    path: "polo2",
    custom: false,
  },
  {
    id: "75",
    name: "Lata",
    category: "Novos2",
    thumbnail: "/models/novos/lata.webp",
    createdAt: "07-09-2025",
    path: "lata",
    custom: false,
    metal: 1,
    brilho: 0
  },
  {
    id: "76",
    name: "Caixa de Leite 500",
    category: "Novos2",
    thumbnail: "/models/novos/milk500.webp",
    createdAt: "07-09-2025",
    path: "milk500",
    custom: false,
    metal: 0,
    brilho: 0.5
  },
  {
    id: "77",
    name: "Caixa de Leite 1000",
    category: "Novos2",
    thumbnail: "/models/novos/milk1000.webp",
    createdAt: "07-09-2025",
    path: "milk1000",
    custom: false,
    metal: 0,
    brilho: 0.5
  },
  {
    id: "78",
    name: "Camisa V",
    category: "Novos2",
    thumbnail: "/models/novos/vneck.webp",
    createdAt: "07-09-2025",
    path: "vneck",
    custom: false,
    metal: 0,
    brilho: 1
  },
  {
    id: "79",
    name: "Top e Short Feminino",
    category: "Novos2",
    thumbnail: "/models/novos/topShorts.webp",
    createdAt: "07-09-2025",
    path: "topShorts",
    custom: false,
    metal: 0,
    brilho: 1
  },
  {
    id: "80",
    name: "Camisa Longa e Leg Feminina",
    category: "Novos2",
    thumbnail: "/models/novos/camisa_short_feminino.webp",
    createdAt: "07-09-2025",
    path: "camisa_short_feminino",
    custom: false,
  },
  {
    id: "81",
    name: "Tank Feminino",
    category: "Novos2",
    thumbnail: "/models/novos/tankFem.webp",
    createdAt: "07-09-2025",
    path: "tankFem",
    custom: false,
  },
  {
    id: "82",
    name: "Leg Feminino",
    category: "Novos2",
    thumbnail: "/models/novos/legging.webp",
    createdAt: "07-09-2025",
    path: "legging",
    custom: false,
    metal: 0,
    brilho: 1
  },
  {
    id: "83",
    name: "Tank Masculino",
    category: "Novos2",
    thumbnail: "/models/novos/tank_masculino.webp",
    createdAt: "08-09-2025",
    path: "tank_masculino",
    custom: false,
    metal: 0,
    brilho: 1
  },
  {
    id: "84",
    name: "Camisa de Manga Curta Masculina",
    category: "Novos2",
    thumbnail: "/models/novos/camisa_de_manga_curta.webp",
    createdAt: "08-09-2025",
    path: "camisa_de_manga_curta",
    custom: false,
  },
  {
    id: "85",
    name: "Meia",
    category: "Novos2",
    thumbnail: "/models/novos/meia.webp",
    createdAt: "08-09-2025",
    path: "meia",
    custom: false,
  },
  {
    id: "86",
    name: "Camiseta feminina manga curta",
    category: "Novos2",
    thumbnail: "/models/novos/camiseta_feminina_manga_curta.webp",
    createdAt: "08-09-2025",
    path: "camiseta_feminina_manga_curta",
    custom: false,
  },
  {
    id: "87",
    name: "Camisa Polo Masculina Longa",
    category: "Novos2",
    thumbnail: "/models/novos/camisa_polo_masculina.webp",
    createdAt: "08-09-2025",
    path: "camisa_polo_masculina",
    custom: false,
  },
  {
    id: "88",
    name: "Camisa Polo Masculina Curta",
    category: "Novos2",
    thumbnail: "/models/novos/camisa_polo_masculina2.webp",
    createdAt: "08-09-2025",
    path: "camisa_polo_masculina2",
    custom: false,
  },
  {
    id: "89",
    name: "Camisa Casual Maculina",
    category: "Novos2",
    thumbnail: "/models/novos/camisa_casual_masculina.webp",
    createdAt: "08-09-2025",
    path: "camisa_casual_masculina",
    custom: false,
  },
  {
    id: "90",
    name: "Camisa Curta Pose 1",
    category: "Novos2",
    thumbnail: "/models/novos/camisas.webp",
    createdAt: "08-09-2025",
    path: "camisas",
    custom: false,
  },
  {
    id: "91",
    name: "Camisa Curta Pose 2",
    category: "Novos2",
    thumbnail: "/models/novos/camisas2.webp",
    createdAt: "08-09-2025",
    path: "camisas2",
    custom: false,
  },
  {
    id: "92",
    name: "Camisa Curta Pose 3",
    category: "Novos2",
    thumbnail: "/models/novos/camisas3.webp",
    createdAt: "08-09-2025",
    path: "camisas3",
    custom: false,
  },
  {
    id: "93",
    name: "Camisa Curta Pose 4",
    category: "Novos2",
    thumbnail: "/models/novos/camisas4.webp",
    createdAt: "08-09-2025",
    path: "camisas4",
    custom: false,
  },
  {
    id: "94",
    name: "MensSweatshirt",
    category: "Novos3",
    thumbnail: "/models/novos/MensSweatshirt.webp",
    createdAt: "06-12-2025",
    path: "MensSweatshirt",
    custom: false,
  },
  {
    id: "95",
    name: "Puffer_Jacket",
    category: "Novos3",
    thumbnail: "/models/novos/Puffer_Jacket.webp",
    createdAt: "06-12-2025",
    path: "Puffer_Jacket",
    custom: false,
  },
  {
    id: "96",
    name: "Bomber_Jacket",
    category: "Novos3",
    thumbnail: "/models/novos/Bomber_Jacket.webp",
    createdAt: "06-12-2025",
    path: "Bomber_Jacket",
    custom: false,
  },
  {
    id: "97",
    name: "Male_Cycling_Jacket",
    category: "Novos3",
    thumbnail: "/models/novos/Male_Cycling_Jacket.webp",
    createdAt: "06-12-2025",
    path: "Male_Cycling_Jacket",
    custom: false,
  },
  {
    id: "98",
    name: "Puffer_Jacket2",
    category: "Novos3",
    thumbnail: "/models/novos/Puffer_Jacket2.webp",
    createdAt: "06-12-2025",
    path: "Puffer_Jacket2",
    custom: false,
  },
  {
    id: "99",
    name: "Baseball_Batting_Gloves",
    category: "Novos3",
    thumbnail: "/models/novos/Baseball_Batting_Gloves.webp",
    createdAt: "06-12-2025",
    path: "Baseball_Batting_Gloves",
    custom: false,
  },
  {
    id: "100",
    name: "Women_Sleeveless_Top",
    category: "Novos3",
    thumbnail: "/models/novos/Women_Sleeveless_Top.webp",
    createdAt: "06-12-2025",
    path: "Women_Sleeveless_Top",
    custom: false,
  },
  {
    id: "101",
    name: "Male_Hooded_Jersey",
    category: "Novos3",
    thumbnail: "/models/novos/Male_Hooded_Jersey.webp",
    createdAt: "06-12-2025",
    path: "Male_Hooded_Jersey",
    custom: false,
  },
  {
    id: "102",
    name: "Women_Half_Sleeve_Raglan_Jersey",
    category: "Novos3",
    thumbnail: "/models/novos/Women_Half_Sleeve_Raglan_Jersey.webp",
    createdAt: "06-12-2025",
    path: "Women_Half_Sleeve_Raglan_Jersey",
    custom: false,
  },
  {
    id: "103",
    name: "Sefety_Vest",
    category: "Novos3",
    thumbnail: "/models/novos/Sefety_Vest.webp",
    createdAt: "06-12-2025",
    path: "Sefety_Vest",
    custom: false,
  },
  {
    id: "104",
    name: "Women_Varsity_Jacket",
    category: "Novos3",
    thumbnail: "/models/novos/Women_Varsity_Jacket.webp",
    createdAt: "06-12-2025",
    path: "Women_Varsity_Jacket",
    custom: false,
  },
  {
    id: "105",
    name: "Knit_Tunic_with_Circle_Skirt",
    category: "Novos3",
    thumbnail: "/models/novos/Knit_Tunic_with_Circle_Skirt.webp",
    createdAt: "06-12-2025",
    path: "Knit_Tunic_with_Circle_Skirt",
    custom: false,
  },
  {
    id: "106",
    name: "Men_Underpants",
    category: "Novos3",
    thumbnail: "/models/novos/Men_Underpants.webp",
    createdAt: "06-12-2025",
    path: "Men_Underpants",
    custom: false,
  },
  {
    id: "107",
    name: "WomenSportsJacket",
    category: "Novos3",
    thumbnail: "/models/novos/WomenSportsJacket.webp",
    createdAt: "06-12-2025",
    path: "WomenSportsJacket",
    custom: false,
  },
  {
    id: "108",
    name: "TwoPieceHoodie",
    category: "Novos3",
    thumbnail: "/models/novos/TwoPieceHoodie.webp",
    createdAt: "06-12-2025",
    path: "TwoPieceHoodie",
    custom: false,
  },
  {
    id: "109",
    name: "LeotardRaglanSleeve",
    category: "Novos3",
    thumbnail: "/models/novos/LeotardRaglanSleeve.webp",
    createdAt: "06-12-2025",
    path: "LeotardRaglanSleeve",
    custom: false,
  },
  {
    id: "110",
    name: "Bodysuit",
    category: "Novos3",
    thumbnail: "/models/novos/Bodysuit.webp",
    createdAt: "06-12-2025",
    path: "Bodysuit",
    custom: false,
  },
  {
    id: "111",
    name: "LeisureVest",
    category: "Novos3",
    thumbnail: "/models/novos/LeisureVest.webp",
    createdAt: "06-12-2025",
    path: "LeisureVest",
    custom: false,
  },
  {
    id: "112",
    name: "MenLongTights",
    category: "Novos3",
    thumbnail: "/models/novos/MenLongTights.webp",
    createdAt: "06-12-2025",
    path: "MenLongTights",
    custom: false,
  },
  {
    id: "113",
    name: "Puffer",
    category: "Novos3",
    thumbnail: "/models/novos/Puffer.webp",
    createdAt: "06-12-2025",
    path: "Puffer",
    custom: false,
  },
  {
    id: "114",
    name: "Raglan",
    category: "Novos3",
    thumbnail: "/models/novos/Raglan.webp",
    createdAt: "06-12-2025",
    path: "Raglan",
    custom: false,
  },
  {
    id: "115",
    name: "High-neck",
    category: "Novos3",
    thumbnail: "/models/novos/High-neck.webp",
    createdAt: "06-12-2025",
    path: "High-neck",
    custom: false,
  },
  {
    id: "116",
    name: "ThermalLongUnderwear",
    category: "Novos3",
    thumbnail: "/models/novos/ThermalLongUnderwear.webp",
    createdAt: "06-12-2025",
    path: "ThermalLongUnderwear",
    custom: false,
  },
  {
    id: "117",
    name: "MenCottonShorts",
    category: "Novos3",
    thumbnail: "/models/novos/MenCottonShorts.webp",
    createdAt: "06-12-2025",
    path: "MenCottonShorts",
    custom: false,
  },
  {
    id: "118",
    name: "Workwear",
    category: "Novos3",
    thumbnail: "/models/novos/Workwear.webp",
    createdAt: "06-12-2025",
    path: "Workwear",
    custom: false,
  },
  {
    id: "119",
    name: "hospital",
    category: "Novos3",
    thumbnail: "/models/novos/hospital.webp",
    createdAt: "06-12-2025",
    path: "hospital",
    custom: false,
  },
  {
    id: "120",
    name: "TankTopandLeggings",
    category: "Novos3",
    thumbnail: "/models/novos/TankTopandLeggings.webp",
    createdAt: "06-12-2025",
    path: "TankTopandLeggings",
    custom: false,
  },
  {
    id: "121",
    name: "DownVest",
    category: "Novos3",
    thumbnail: "/models/novos/DownVest.webp",
    createdAt: "06-12-2025",
    path: "DownVest",
    custom: false,
  },
  {
    id: "122",
    name: "T-ShirtJersey",
    category: "Novos3",
    thumbnail: "/models/novos/T-ShirtJersey.webp",
    createdAt: "06-12-2025",
    path: "T-ShirtJersey",
    custom: false,
  },
  {
    id: "123",
    name: "WomenBlazerOutfit",
    category: "Novos3",
    thumbnail: "/models/novos/WomenBlazerOutfit.webp",
    createdAt: "06-12-2025",
    path: "WomenBlazerOutfit",
    custom: false,
  },
  {
    id: "124",
    name: "TankTop",
    category: "Novos3",
    thumbnail: "/models/novos/TankTop.webp",
    createdAt: "06-12-2025",
    path: "TankTop",
    custom: false,
  },
  {
    id: "125",
    name: "LabCoat",
    category: "Novos3",
    thumbnail: "/models/novos/LabCoat.webp",
    createdAt: "06-12-2025",
    path: "LabCoat",
    custom: false,
  },
  {
    id: "126",
    name: "Bodysuit2",
    category: "Novos3",
    thumbnail: "/models/novos/Bodysuit2.webp",
    createdAt: "06-12-2025",
    path: "Bodysuit2",
    custom: false,
  },
  {
    id: "127",
    name: "RainJacket",
    category: "Novos3",
    thumbnail: "/models/novos/RainJacket.webp",
    createdAt: "06-12-2025",
    path: "RainJacket",
    custom: false,
  },
  {
    id: "128",
    name: "Raincoat2",
    category: "Novos3",
    thumbnail: "/models/novos/Raincoat2.webp",
    createdAt: "06-12-2025",
    path: "Raincoat2",
    custom: false,
  },
  {
    id: "129",
    name: "PleatedMiniSkirt",
    category: "Novos3",
    thumbnail: "/models/novos/PleatedMiniSkirt.webp",
    createdAt: "06-12-2025",
    path: "PleatedMiniSkirt",
    custom: false,
  },
  {
    id: "130",
    name: "TailoredShorts",
    category: "Novos3",
    thumbnail: "/models/novos/TailoredShorts.webp",
    createdAt: "06-12-2025",
    path: "TailoredShorts",
    custom: false,
  },
  {
    id: "131",
    name: "BaggyCargoPants",
    category: "Novos3",
    thumbnail: "/models/novos/BaggyCargoPants.webp",
    createdAt: "06-12-2025",
    path: "BaggyCargoPants",
    custom: false,
  },
  {
    id: "132",
    name: "TShirtshortsleeve",
    category: "Novos3",
    thumbnail: "/models/novos/TShirtshortsleeve.webp",
    createdAt: "06-12-2025",
    path: "TShirtshortsleeve",
    custom: false,
  },
  {
    id: "133",
    name: "VarsityJacket",
    category: "Novos3",
    thumbnail: "/models/novos/VarsityJacket.webp",
    createdAt: "06-12-2025",
    path: "VarsityJacket",
    custom: false,
  },
  {
    id: "134",
    name: "MensJersey",
    category: "Novos3",
    thumbnail: "/models/novos/MensJersey.webp",
    createdAt: "06-12-2025",
    path: "MensJersey",
    custom: false,
  },
  {
    id: "135",
    name: "MensOversizedTShirt",
    category: "Novos3",
    thumbnail: "/models/novos/MensOversizedTShirt.webp",
    createdAt: "06-12-2025",
    path: "MensOversizedTShirt",
    custom: false,
  },
  {
    id: "136",
    name: "MensRegularFitTShirt",
    category: "Novos3",
    thumbnail: "/models/novos/MensRegularFitTShirt.webp",
    createdAt: "06-12-2025",
    path: "MensRegularFitTShirt",
    custom: false,
  },
  {
    id: "137",
    name: "Raglan",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/137.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/137",
    custom: false,
  },
  {
    id: "138",
    name: "Tank Top",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/138.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/138",
    custom: false,
  },
  {
    id: "139",
    name: "Jersey",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/139.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/139",
    custom: false,
    wiggle: false,
  },
  {
    id: "140",
    name: "Camiseta Manga Curta",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/140.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/140",
    custom: false,
  },
  {
    id: "141",
    name: "Baseball Jersey",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/141.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/141",
    custom: false,
  },
  {
    id: "142",
    name: "Colete",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/142.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/142",
    custom: false,
  },
  {
    id: "143",
    name: "Camisola de ciclismo de manga curta feminina",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/143.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/143",
    custom: false,
  },
  {
    id: "144",
    name: "Camisola de ciclismo de manga longa feminina",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/144.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/144",
    custom: false,
  },
  {
    id: "145",
    name: "Camisa de Ciclismo Manga Comprida Homem",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/145.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/145",
    custom: false,
  },
  {
    id: "146",
    name: "Basketball Camisa",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/146.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/146",
    custom: false,
  },
  {
    id: "147",
    name: "Basketball Short",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/147.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/147",
    custom: false,
  },
  {
    id: "148",
    name: "Camisa Regular Gola Redonda",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/148.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/148",
    custom: false,
  },
  {
    id: "149",
    name: "Camiseta masculina grande redonda",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/149.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/149",
    custom: false,
  },
  {
    id: "150",
    name: "Jersey Longa",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/150.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/150",
    custom: false,
  },
  {
    id: "151",
    name: "Polo",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/151.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/151",
    custom: false,
  },
  {
    id: "152",
    name: "Calça",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/152.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/152",
    custom: false,
  },
  {
    id: "153",
    name: "Camiseta no Cabide",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/153.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/153",
    custom: false,
  },
  {
    id: "154",
    name: "Camiseta no Cabide 2",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/154.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/154",
    custom: false,
  },
  {
    id: "155",
    name: "Short",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/155.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/155",
    custom: false,
  },
  {
    id: "156",
    name: "Boné 1",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/156.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/156",
    custom: false,
  },
  {
    id: "157",
    name: "Boné 2",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/157.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/157",
    custom: false,
  },
  {
    id: "158",
    name: "Travesseiro",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/158.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/158",
    custom: false,
  },
  {
    id: "159",
    name: "Touca",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/159.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/159",
    custom: false,
  },
  {
    id: "160",
    name: "Colete Futebol",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/160.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/160",
    custom: false,
  },
  {
    id: "161",
    name: "Jaqueta",
    category: "bases_novas_física",
    thumbnail: "/models/novos/cgtrader/161.webp",
    createdAt: "06-12-2025",
    path: "cgtrader/161",
    custom: false,
    wiggle: true
  },
  {
    id: "162",
    name: "Camisa Masculina com Capuz 2",
    category: "bases_novas_física",
    thumbnail: "/models/novos/cgtrader/162.webp",
    createdAt: "29-12-2025",
    path: "cgtrader/162",
    custom: false,
  },
  {
    id: "163",
    name: "Camisa Masculina",
    category: "bases_novas_física",
    thumbnail: "/models/novos/cgtrader/163.webp",
    createdAt: "29-12-2025",
    path: "cgtrader/163",
    custom: false,
    wiggle: true
  },
  {
    id: "164",
    name: "Camiseta Feminina Meio Zíper",
    category: "bases_novas_física",
    thumbnail: "/models/novos/cgtrader/164.webp",
    createdAt: "29-12-2025",
    path: "cgtrader/164",
    custom: false,
  },
  {
    id: "165",
    name: "Cabide com capuz masculino",
    category: "bases_novas_física",
    thumbnail: "/models/novos/cgtrader/165.webp",
    createdAt: "29-12-2025",
    path: "cgtrader/165",
    custom: false,
  },
  {
    id: "166",
    name: "Caneca 1",
    category: "cgtrader",
    thumbnail: "/models/novos/canecas/166.webp",
    createdAt: "05-01-2026",
    path: "canecas/166",
    custom: false,
    wiggle: false,
  },
  {
    id: "167",
    name: "Caneca 2",
    category: "canecas",
    thumbnail: "/models/novos/canecas/167.webp",
    createdAt: "05-01-2026",
    path: "canecas/167",
    custom: false,
    wiggle: false,
  },






  {
    id: "168",
    name: "Caneca 3",
    category: "canecas",
    thumbnail: "/models/novos/canecas/168.webp",
    createdAt: "05-01-2026",
    path: "canecas/168",
    custom: false,
    wiggle: false,
  },
  {
    id: "169",
    name: "Caneca 4",
    category: "canecas",
    thumbnail: "/models/novos/canecas/169.webp",
    createdAt: "05-01-2026",
    path: "canecas/169",
    custom: false,
    wiggle: false,
  },
  {
    id: "170",
    name: "Caneca 5",
    category: "canecas",
    thumbnail: "/models/novos/canecas/170.webp",
    createdAt: "05-01-2026",
    path: "canecas/170",
    custom: false,
    wiggle: false,
  },
  {
    id: "171",
    name: "Caneca 6",
    category: "canecas",
    thumbnail: "/models/novos/canecas/171.webp",
    createdAt: "05-01-2026",
    path: "canecas/171",
    custom: false,
    wiggle: false,
  },
  {
    id: "172",
    name: "Caneca 7",
    category: "canecas",
    thumbnail: "/models/novos/canecas/172.webp",
    createdAt: "05-01-2026",
    path: "canecas/172",
    custom: false,
    wiggle: false,
  },
  {
    id: "173",
    name: "Caneca 8",
    category: "canecas",
    thumbnail: "/models/novos/canecas/173.webp",
    createdAt: "05-01-2026",
    path: "canecas/173",
    custom: false,
    wiggle: false,
  },
  {
    id: "174",
    name: "Caneca 9",
    category: "canecas",
    thumbnail: "/models/novos/canecas/174.webp",
    createdAt: "05-01-2026",
    path: "canecas/174",
    custom: false,
    wiggle: false,
  },
  {
    id: "175",
    name: "Caneca 10",
    category: "canecas",
    thumbnail: "/models/novos/canecas/175.webp",
    createdAt: "05-01-2026",
    path: "canecas/175",
    custom: false,
    wiggle: false,
  },





  {
    id: "176",
    name: "Caneca 11",
    category: "canecas",
    thumbnail: "/models/novos/canecas/176.webp",
    createdAt: "05-01-2026",
    path: "canecas/176",
    custom: false,
    wiggle: false,
  },
  {
    id: "177",
    name: "Caneca 12",
    category: "canecas",
    thumbnail: "/models/novos/canecas/177.webp",
    createdAt: "05-01-2026",
    path: "canecas/177",
    custom: false,
    wiggle: false,
  },
  {
    id: "178",
    name: "Caneca 13",
    category: "canecas",
    thumbnail: "/models/novos/canecas/178.webp",
    createdAt: "05-01-2026",
    path: "canecas/178",
    custom: false,
    wiggle: false,
  },
  {
    id: "179",
    name: "Caneca 14",
    category: "canecas",
    thumbnail: "/models/novos/canecas/179.webp",
    createdAt: "05-01-2026",
    path: "canecas/179",
    custom: false,
    wiggle: false,
  },
  {
    id: "180",
    name: "Caneca 15",
    category: "canecas",
    thumbnail: "/models/novos/canecas/180.webp",
    createdAt: "05-01-2026",
    path: "canecas/180",
    custom: false,
    wiggle: false,
  },
  {
    id: "181",
    name: "Caneca 16",
    category: "canecas",
    thumbnail: "/models/novos/canecas/181.webp",
    createdAt: "05-01-2026",
    path: "canecas/181",
    custom: false,
    wiggle: false,
  },
  {
    id: "182",
    name: "Caneca 17",
    category: "canecas",
    thumbnail: "/models/novos/canecas/182.webp",
    createdAt: "05-01-2026",
    path: "canecas/182",
    custom: false,
    wiggle: false,
  },
  {
    id: "183",
    name: "Caneca 18",
    category: "canecas",
    thumbnail: "/models/novos/canecas/183.webp",
    createdAt: "05-01-2026",
    path: "canecas/183",
    custom: false,
    wiggle: false,
  },
  {
    id: "184",
    name: "Caneca 19",
    category: "canecas",
    thumbnail: "/models/novos/canecas/184.webp",
    createdAt: "05-01-2026",
    path: "canecas/184",
    custom: false,
    wiggle: false,
    metal: 1
  },
  {
    id: "185",
    name: "Caneca 20",
    category: "canecas",
    thumbnail: "/models/novos/canecas/185.webp",
    createdAt: "05-01-2026",
    path: "canecas/185",
    custom: false,
    wiggle: false
  },

  {
    id: "186",
    name: "Camisa de ciclismo manga longa masculina",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/186.webp",
    createdAt: "05-01-2026",
    path: "cgtrader/186",
    custom: false,
    wiggle: false
  },

  {
    id: "187",
    name: "Abada Teste",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/187.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/187",
    custom: false,
    wiggle: true
  },
  {
    id: "188",
    name: "Camisa Pesca",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/188.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/188",
    custom: false,
    wiggle: true
  },
  {
    id: "189",
    name: "Calça",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/189.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/189",
    custom: false,
    wiggle: true
  },
  {
    id: "190",
    name: "Camisa Pesca Balaclava",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/190.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/190",
    custom: false,
    wiggle: true
  },
  {
    id: "191",
    name: "Camisa Pesca Nova",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/191.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/191",
    custom: false,
    wiggle: true
  },
  {
    id: "192",
    name: "Polo Normal",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/192.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/192",
    custom: false,
    wiggle: true
  },
  {
    id: "193",
    name: "Polo Raglan",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/193.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/193",
    custom: false,
    wiggle: true
  },
  {
    id: "194",
    name: "Rashguard",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/194.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/194",
    custom: false,
    wiggle: true
  },
  {
    id: "195",
    name: "Regata Academia",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/195.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/195",
    custom: false,
    wiggle: true
  },
  {
    id: "196",
    name: "Regata Basquete V",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/196.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/196",
    custom: false,
    wiggle: true
  },
  {
    id: "197",
    name: "Regata Volei",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/197.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/197",
    custom: false,
    wiggle: true
  },
  {
    id: "198",
    name: "Short Feminino",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/198.webp",
    createdAt: "05-01-2026",
    path: "bases_novas/198",
    custom: false,
    wiggle: true
  },
  {
    id: "199",
    name: "Abadá Clone Sports",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/199.webp",
    createdAt: "08-01-2026",
    path: "bases_novas/199",
    custom: false,
    wiggle: true
  },
  {
    id: "200",
    name: "Camisa Agro",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/200.webp",
    createdAt: "13-01-2026",
    path: "bases_novas/200",
    custom: false,
    wiggle: true
  },

  {
    id: "201",
    name: "Conjunto 1",
    category: "webster",
    thumbnail: "/models/novos/webster/201.webp",
    createdAt: "15-01-2026",
    path: "webster/201",
    custom: false,
    wiggle: true
  },
  {
    id: "202",
    name: "Conjunto 2",
    category: "webster",
    thumbnail: "/models/novos/webster/202.webp",
    createdAt: "15-01-2026",
    path: "webster/202",
    custom: false,
    wiggle: true
  },

  {
    id: "203",
    name: "Conjunto 3",
    category: "webster",
    thumbnail: "/models/novos/webster/203.webp",
    createdAt: "15-01-2026",
    path: "webster/203",
    custom: false,
    wiggle: false
  },
  {
    id: "204",
    name: "Conjunto 4",
    category: "webster",
    thumbnail: "/models/novos/webster/204.webp",
    createdAt: "15-01-2026",
    path: "webster/204",
    custom: false,
    wiggle: true
  },
  {
    id: "205",
    name: "Conjunto 5",
    category: "webster",
    thumbnail: "/models/novos/webster/205.webp",
    createdAt: "15-01-2026",
    path: "webster/205",
    custom: false,
    wiggle: true
  },
  {
    id: "206",
    name: "Conjunto 6",
    category: "webster",
    thumbnail: "/models/novos/webster/206.webp",
    createdAt: "15-01-2026",
    path: "webster/206",
    custom: false,
    wiggle: true
  },
  {
    id: "207",
    name: "Conjunto 7",
    category: "webster",
    thumbnail: "/models/novos/webster/207.webp",
    createdAt: "15-01-2026",
    path: "webster/207",
    custom: false,
    wiggle: true
  },
  {
    id: "208",
    name: "Conjunto 8",
    category: "webster",
    thumbnail: "/models/novos/webster/208.webp",
    createdAt: "15-01-2026",
    path: "webster/208",
    custom: false,
    wiggle: true
  },
  {
    id: "209",
    name: "Conjunto 9",
    category: "webster",
    thumbnail: "/models/novos/webster/209.webp",
    createdAt: "15-01-2026",
    path: "webster/209",
    custom: false,
    wiggle: true
  },
  {
    id: "210",
    name: "Conjunto 10",
    category: "webster",
    thumbnail: "/models/novos/webster/210.webp",
    createdAt: "15-01-2026",
    path: "webster/210",
    custom: false,
    wiggle: true
  },
  {
    id: "211",
    name: "Conjunto 11",
    category: "webster",
    thumbnail: "/models/novos/webster/211.webp",
    createdAt: "15-01-2026",
    path: "webster/211",
    custom: false,
    wiggle: true
  },
  {
    id: "212",
    name: "Conjunto 12",
    category: "webster",
    thumbnail: "/models/novos/webster/212.webp",
    createdAt: "15-01-2026",
    path: "webster/212",
    custom: false,
    wiggle: true
  },
  {
    id: "213",
    name: "Conjunto 13",
    category: "webster",
    thumbnail: "/models/novos/webster/213.webp",
    createdAt: "15-01-2026",
    path: "webster/213",
    custom: false,
    wiggle: true
  },
  {
    id: "214",
    name: "Conjunto 14",
    category: "webster",
    thumbnail: "/models/novos/webster/214.webp",
    createdAt: "15-01-2026",
    path: "webster/214",
    custom: false,
    wiggle: true
  },
  {
    id: "215",
    name: "Conjunto 15",
    category: "webster",
    thumbnail: "/models/novos/webster/215.webp",
    createdAt: "15-01-2026",
    path: "webster/215",
    custom: false,
    wiggle: true
  },
  {
    id: "216",
    name: "Conjunto 16",
    category: "webster",
    thumbnail: "/models/novos/webster/216.webp",
    createdAt: "15-01-2026",
    path: "webster/216",
    custom: false,
    wiggle: true
  },
  {
    id: "217",
    name: "Conjunto 17",
    category: "webster",
    thumbnail: "/models/novos/webster/217.webp",
    createdAt: "15-01-2026",
    path: "webster/217",
    custom: false,
    wiggle: true
  },
  {
    id: "218",
    name: "Conjunto 18",
    category: "webster",
    thumbnail: "/models/novos/webster/218.webp",
    createdAt: "15-01-2026",
    path: "webster/218",
    custom: false,
    wiggle: true
  },
  {
    id: "219",
    name: "Conjunto 19",
    category: "webster",
    thumbnail: "/models/novos/webster/219.webp",
    createdAt: "15-01-2026",
    path: "webster/219",
    custom: false,
    wiggle: true
  },

  {
    id: "220",
    name: "Short Feminino",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/220.webp",
    createdAt: "16-01-2026",
    path: "bases_novas/220",
    custom: false,
    wiggle: true
  },
  {
    id: "221",
    name: "Vestido GOLA V",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/221.webp",
    createdAt: "16-01-2026",
    path: "bases_novas/221",
    custom: false,
    wiggle: true
  },
  {
    id: "222",
    name: "Vestido GOLA CARECA",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/222.webp",
    createdAt: "16-01-2026",
    path: "bases_novas/222",
    custom: false,
    wiggle: true
  },
  {
    id: "223",
    name: "Conjunto Standard",
    category: "fifa",
    thumbnail: "/models/novos/conjuntos/223.webp",
    createdAt: "10-02-2026",
    path: "conjuntos/223",
    custom: false,
    wiggle: false
  },
  {
    id: "224",
    name: "Conjunto Apertado",
    category: "fifa",
    thumbnail: "/models/novos/conjuntos/224.webp",
    createdAt: "14-02-2026",
    path: "conjuntos/224",
    custom: false,
    wiggle: false
  },
  {
    id: "225",
    name: "Mini Kit",
    category: "fifa",
    thumbnail: "/models/novos/conjuntos/225.webp",
    createdAt: "14-02-2026",
    path: "conjuntos/225",
    custom: false,
    wiggle: false
  },
  {
    id: "226",
    name: "Conjunto Feminino",
    category: "fifa",
    thumbnail: "/models/novos/conjuntos/226.webp",
    createdAt: "14-02-2026",
    path: "conjuntos/226",
    custom: false,
    wiggle: false
  },
  {
    id: "227",
    name: "Cabide",
    category: "fifa",
    thumbnail: "/models/novos/conjuntos/227.webp",
    createdAt: "14-02-2026",
    path: "conjuntos/227",
    custom: false,
    wiggle: false
  },
  {
    id: "228",
    name: "Flutuando",
    category: "fifa",
    thumbnail: "/models/novos/conjuntos/228.webp",
    createdAt: "14-02-2026",
    path: "conjuntos/228",
    custom: false,
    wiggle: false
  },

  /****************************************************************************************** */

  {
    id: "229",
    name: "Babylook Gola O Bainha",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/229.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/229",
    custom: false,
    wiggle: false
  },
  {
    id: "230",
    name: "Babylook Gola O Barra",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/230.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/230",
    custom: false,
    wiggle: false
  },
  {
    id: "231",
    name: "Babylook Gola O Manga Longa",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/231.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/231",
    custom: false,
    wiggle: false
  },
  {
    id: "232",
    name: "Babylook Gola V Bainha",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/232.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/232",
    custom: false,
    wiggle: true
  },
  {
    id: "233",
    name: "Babylook Gola V Barra",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/233.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/233",
    custom: false,
    wiggle: false
  },
  {
    id: "234",
    name: "Babylook Gola V Manga Longa",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/234.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/234",
    custom: false,
    wiggle: false
  },
  {
    id: "235",
    name: "CAMISA Gola O Bainha",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/235.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/235",
    custom: false,
    wiggle: false
  },
  {
    id: "236",
    name: "CAMISA Gola O Barra",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/236.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/236",
    custom: false,
    wiggle: false
  },
  {
    id: "237",
    name: "CAMISA Gola O Manga Longa",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/237.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/237",
    custom: false,
    wiggle: false
  },
  {
    id: "238",
    name: "CAMISA Gola V Bainha",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/238.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/238",
    custom: false,
    wiggle: false
  },
  {
    id: "239",
    name: "CAMISA Gola V Barra",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/239.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/239",
    custom: false,
    wiggle: false
  },
  {
    id: "240",
    name: "CAMISA Gola V Manga Longa",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/240.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/240",
    custom: false,
    wiggle: false
  },
  {
    id: "241",
    name: "CICLISMO ZIPER NO MEIO",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/241.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/241",
    custom: false,
    wiggle: false
  },
  {
    id: "242",
    name: "CICLISMO ZIPER PEQUENO",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/242.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/242",
    custom: false,
    wiggle: false
  },
  {
    id: "243",
    name: "COLETE ABERTURA LATERAL",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/243.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/243",
    custom: false,
    wiggle: false
  },
  {
    id: "244",
    name: "COLETE FECHAMENTO LATERAL",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/244.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/244",
    custom: false,
    wiggle: false
  },
  {
    id: "245",
    name: "Futvolei Regata Gola O",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/245.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/245",
    custom: false,
    wiggle: false
  },
  {
    id: "246",
    name: "Futvolei Regata Gola V",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/246.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/246",
    custom: false,
    wiggle: false
  },
  {
    id: "247",
    name: "RAGLAN BABYLOOK Gola O Bainha",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/247.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/247",
    custom: false,
    wiggle: false
  },
  {
    id: "248",
    name: "RAGLAN BABYLOOK Gola O Manga Longa",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/248.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/248",
    custom: false,
    wiggle: false
  },
  {
    id: "249",
    name: "RAGLAN BABYLOOK Gola V Bainha",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/249.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/249",
    custom: false,
    wiggle: false
  },
  {
    id: "250",
    name: "RAGLAN BABYLOOK Gola V Manga Longa",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/250.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/250",
    custom: false,
    wiggle: false
  },
  {
    id: "251",
    name: "RAGLAN CAMISA Gola O Bainha",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/251.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/251",
    custom: false,
    wiggle: false
  },
  {
    id: "252",
    name: "RAGLAN CAMISA Gola O Manga Longa",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/252.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/252",
    custom: false,
    wiggle: false
  },
  {
    id: "253",
    name: "RAGLAN CAMISA Gola V Bainha",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/253.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/253",
    custom: false,
    wiggle: false
  },
  {
    id: "254",
    name: "RAGLAN CAMISA Gola V Manga Longa",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/254.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/254",
    custom: false,
    wiggle: false
  },
  {
    id: "255",
    name: "REGATA MACHÃO GOLA O",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/255.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/255",
    custom: false,
    wiggle: false
  },
  {
    id: "256",
    name: "REGATA MACHÃO GOLA V",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/256.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/256",
    custom: false,
    wiggle: false
  },
  {
    id: "257",
    name: "REGATA BASQUETE GOLA O",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/257.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/257",
    custom: false,
    wiggle: false
  },
  {
    id: "258",
    name: "REGATA BASQUETE GOLA V",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/258.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/258",
    custom: false,
    wiggle: false
  },
  {
    id: "259",
    name: "VOLEI FEMININO SHORT CURTO RGT Gola O",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/259.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/259",
    custom: false,
    wiggle: false
  },
  {
    id: "260",
    name: "VOLEI FEMININO SHORT CURTO RGT Gola V",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/260.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/260",
    custom: false,
    wiggle: false
  },
  {
    id: "261",
    name: "VOLEI FEMININO SHORT LONGO RGT Gola O",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/261.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/261",
    custom: false,
    wiggle: false
  },
  {
    id: "262",
    name: "VOLEI FEMININO SHORT LONGO RGT Gola V",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/262.webp",
    createdAt: "25-02-2026",
    path: "sisbolt_novos_mockups/262",
    custom: false,
    wiggle: false
  },
  {
    id: "263",
    name: "Bolsa",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/263.webp",
    createdAt: "13-03-2026",
    path: "sisbolt_novos_mockups/263",
    custom: false,
    wiggle: false
  },

  {
    id: "264",
    name: "Camisa Agro - Raglan curta",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/264.webp",
    createdAt: "17-03-2026",
    path: "sisbolt_novos_mockups/264",
    custom: false,
    wiggle: false
  },
  {
    id: "265",
    name: "Camisa Agro - Raglan longa",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/265.webp",
    createdAt: "17-03-2026",
    path: "sisbolt_novos_mockups/265",
    custom: false,
    wiggle: false
  },
  {
    id: "266",
    name: "Camisa Agro - tradicional curta",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/266.webp",
    createdAt: "17-03-2026",
    path: "sisbolt_novos_mockups/266",
    custom: false,
    wiggle: false
  },
  {
    id: "267",
    name: "Camisa Agro - tradicional longa",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/267.webp",
    createdAt: "17-03-2026",
    path: "sisbolt_novos_mockups/267",
    custom: false,
    wiggle: false
  },

  {
    id: "268",
    name: "KIT JERSEY Padrão",
    category: "kits",
    thumbnail: "/models/novos/kits/268.webp",
    createdAt: "20-03-2026",
    path: "kits/268",
    custom: false,
    wiggle: false
  },
  {
    id: "269",
    name: "KIT JERSEY Dribble",
    category: "kits",
    thumbnail: "/models/novos/kits/269.webp",
    createdAt: "20-03-2026",
    path: "kits/269",
    custom: false,
    wiggle: false
  },
  {
    id: "270",
    name: "KIT JERSEY Correndo",
    category: "kits",
    thumbnail: "/models/novos/kits/270.webp",
    createdAt: "20-03-2026",
    path: "kits/270",
    custom: false,
    wiggle: false
  },
  {
    id: "271",
    name: "KIT JERSEY Chutando",
    category: "kits",
    thumbnail: "/models/novos/kits/271.webp",
    createdAt: "20-03-2026",
    path: "kits/271",
    custom: false,
    wiggle: false
  },
  {
    id: "272",
    name: "KIT JERSEY Pisando na Bola",
    category: "kits",
    thumbnail: "/models/novos/kits/272.webp",
    createdAt: "20-03-2026",
    path: "kits/272",
    custom: false,
    wiggle: false
  },
  {
    id: "273",
    name: "KIT JERSEY Carrinho",
    category: "kits",
    thumbnail: "/models/novos/kits/273.webp",
    createdAt: "20-03-2026",
    path: "kits/273",
    custom: false,
    wiggle: false
  },

  {
    id: "274",
    name: "RAGLAN FEMININO",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/274.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/274",
    custom: false,
    wiggle: false
  },
  {
    id: "275",
    name: "TRADICIONAL MANG. LONGA",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/275.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/275",
    custom: false,
    wiggle: false
  },
  {
    id: "276",
    name: "TRADICIONAL MANG. CURTA",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/276.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/276",
    custom: false,
    wiggle: false
  },
  {
    id: "277",
    name: "RASHGUARD",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/277.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/277",
    custom: false,
    wiggle: false
  },
  {
    id: "278",
    name: "RAGLAN",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/278.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/278",
    custom: false,
    wiggle: false
  },
  {
    id: "279",
    name: "PREMIUM MANGA LONGA GOLA V",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/279.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/279",
    custom: false,
    wiggle: false
  },
  {
    id: "280",
    name: "PREMIUM MANGA LONGA GOLA O",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/280.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/280",
    custom: false,
    wiggle: false
  },
  {
    id: "281",
    name: "PREMIUM MANGA CURTA GOLA V",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/281.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/281",
    custom: false,
    wiggle: false
  },
  {
    id: "282",
    name: "PREMIUM MANGA CURTA GOLA O",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/282.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/282",
    custom: false,
    wiggle: false
  },
  {
    id: "283",
    name: "ABADÁ",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/283.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/283",
    custom: false,
    wiggle: false
  },
  {
    id: "284",
    name: "MOLETOM",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/284.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/284",
    custom: false,
    wiggle: false
  },
  {
    id: "285",
    name: "AGASALHO",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/285.webp",
    createdAt: "10-04-2026",
    path: "sisbolt_novos_mockups/285",
    custom: false,
    wiggle: false
  },

  {
    id: "286",
    name: "ZIPPER LONGA MASCULINA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/286.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/286",
    custom: false,
    wiggle: false
  },
  {
    id: "287",
    name: "ZIPPER LONGA CRIANÇA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/287.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/287",
    custom: false,
    wiggle: false
  },
  {
    id: "288",
    name: "ZIPPER LONGA FEMENINA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/288.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/288",
    custom: false,
    wiggle: false
  },
  {
    id: "289",
    name: "ZIPPER CURTA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/289.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/289",
    custom: false,
    wiggle: false
  },
  {
    id: "290",
    name: "ZIPPER CURTA FEMENINA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/290.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/290",
    custom: false,
    wiggle: false
  },
  {
    id: "291",
    name: "SURFISTA LONGA FEMENINA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/291.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/291",
    custom: false,
    wiggle: false
  },
  {
    id: "292",
    name: "SURFISTA LONGA Masculina",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/292.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/292",
    custom: false,
    wiggle: false
  },
  {
    id: "293",
    name: "SURFISTA CURTA CRIANÇA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/293.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/293",
    custom: false,
    wiggle: false
  },
  {
    id: "294",
    name: "POLO  FEMENINA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/294.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/294",
    custom: false,
    wiggle: false
  },
  {
    id: "295",
    name: "CAPUZ LONGA COM BUFF FEMENINA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/295.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/295",
    custom: false,
    wiggle: false
  },
  {
    id: "296",
    name: "CAPUZ LONGA COM BUFF MASCULINA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/296.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/296",
    custom: false,
    wiggle: false
  },
  {
    id: "297",
    name: "CAPUZ LONGA FEMENINA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/297.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/297",
    custom: false,
    wiggle: false
  },
  {
    id: "298",
    name: "CAPUZ LONGA MASCULINA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/298.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/298",
    custom: false,
    wiggle: false
  },
  {
    id: "299",
    name: "POLO MASCULINA",
    category: "pesca_e_surf",
    thumbnail: "/models/novos/pesca_e_surf/299.webp",
    createdAt: "16-04-2026",
    path: "pesca_e_surf/299",
    custom: false,
    wiggle: false
  },

  //

  {
    id: "300",
    name: "CAMISA GOLA V TRANSPASSADA - MANGA LONGA SEM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/300.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/300",
    custom: false,
    wiggle: false
  },
  {
    id: "301",
    name: "CAMISA GOLA O - MANGA CURTA COM BARRA",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/301.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/301",
    custom: false,
    wiggle: false
  },
  {
    id: "302",
    name: "CAMISA GOLA O - MANGA CURTA NORMAL",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/302.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/302",
    custom: false,
    wiggle: false
  },
  {
    id: "303",
    name: "CAMISA GOLA O - MANGA LONGA SEM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/303.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/303",
    custom: false,
    wiggle: false
  },
  {
    id: "304",
    name: "CAMISA GOLA PADRE - MANGA CURTA COM BARRA",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/304.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/304",
    custom: false,
    wiggle: false
  },
  {
    id: "305",
    name: "CAMISA GOLA PADRE - MANGA CURTA NORMAL",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/305.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/305",
    custom: false,
    wiggle: false
  },
  {
    id: "306",
    name: "CAMISA GOLA PADRE - MANGA LONGA COM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/306.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/306",
    custom: false,
    wiggle: false
  },
  {
    id: "307",
    name: "CAMISA GOLA PADRE - MANGA LONGA SEM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/307.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/307",
    custom: false,
    wiggle: false
  },
  {
    id: "308",
    name: "CAMISA GOLA V AFINADA - MANGA CURTA COM BARRA",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/308.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/308",
    custom: false,
    wiggle: false
  },
  {
    id: "309",
    name: "CAMISA GOLA V AFINADA - MANGA CURTA NORMAL",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/309.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/309",
    custom: false,
    wiggle: false
  },
  {
    id: "310",
    name: "CAMISA GOLA V AFINADA - MANGA LONGA COM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/310.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/310",
    custom: false,
    wiggle: false
  },
  {
    id: "311",
    name: "CAMISA GOLA V AFINADA - MANGA LONGA SEM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/311.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/311",
    custom: false,
    wiggle: false
  },
  {
    id: "312",
    name: "CAMISA GOLA V COMUM - MANGA CURTA COM BARRA",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/312.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/312",
    custom: false,
    wiggle: false
  },
  {
    id: "313",
    name: "CAMISA GOLA V COMUM - MANGA CURTA NORMAL",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/313.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/313",
    custom: false,
    wiggle: false
  },
  {
    id: "314",
    name: "CAMISA GOLA V COMUM - MANGA LONGA COM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/314.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/314",
    custom: false,
    wiggle: false
  },
  {
    id: "315",
    name: "CAMISA GOLA V COMUM - MANGA LONGA SEM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/315.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/315",
    custom: false,
    wiggle: false
  },
  {
    id: "316",
    name: "CAMISA GOLA V SEM FIM - MANGA CURTA COM BARRA",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/316.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/316",
    custom: false,
    wiggle: false
  },
  {
    id: "317",
    name: "CAMISA GOLA V SEM FIM - MANGA CURTA NORMAL",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/317.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/317",
    custom: false,
    wiggle: false
  },
  {
    id: "318",
    name: "CAMISA GOLA V SEM FIM - MANGA LONGA COM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/318.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/318",
    custom: false,
    wiggle: false
  },
  {
    id: "319",
    name: "CAMISA GOLA V SEM FIM - MANGA LONGA SEM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/319.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/319",
    custom: false,
    wiggle: false
  },
  {
    id: "320",
    name: "CAMISA GOLA V SOBREPOSTA - MANGA CURTA COM BARRA",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/320.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/320",
    custom: false,
    wiggle: false
  },
  {
    id: "321",
    name: "CAMISA GOLA V SOBREPOSTA - MANGA CURTA NORMAL",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/321.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/321",
    custom: false,
    wiggle: false
  },
  {
    id: "322",
    name: "CAMISA GOLA V SOBREPOSTA - MANGA LONGA COM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/322.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/322",
    custom: false,
    wiggle: false
  },
  {
    id: "323",
    name: "CAMISA GOLA V SOBREPOSTA - MANGA LONGA SEM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/323.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/323",
    custom: false,
    wiggle: false
  },
  {
    id: "324",
    name: "CAMISA GOLA V TRANSPASSADA - MANGA CURTA COM BARRA",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/324.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/324",
    custom: false,
    wiggle: false
  },
  {
    id: "325",
    name: "CAMISA GOLA V TRANSPASSADA - MANGA CURTA NORMAL",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/325.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/325",
    custom: false,
    wiggle: false
  },
  {
    id: "326",
    name: "CAMISA GOLA V TRANSPASSADA - MANGA LONGA COM PUNHO",
    category: "Modular - Superior",
    thumbnail: "/models/novos/modular/SUPERIOR/326.webp",
    createdAt: "16-05-2026",
    path: "modular/SUPERIOR/326",
    custom: false,
    wiggle: false
  },
  {
    id: "327",
    name: "CALÇÃO FUT ATTACK 5 RECORTES",
    category: "Modular - Inferior",
    thumbnail: "/models/novos/modular/INFERIOR/327.webp",
    createdAt: "16-05-2026",
    path: "modular/INFERIOR/327",
    custom: false,
    wiggle: false
  },
  {
    id: "328",
    name: "CALÇÃO FUTEBOL 2 PARTES",
    category: "Modular - Inferior",
    thumbnail: "/models/novos/modular/INFERIOR/328.webp",
    createdAt: "16-05-2026",
    path: "modular/INFERIOR/328",
    custom: false,
    wiggle: false
  },
  {
    id: "329",
    name: "CALÇÃO FUTEBOL 4 PARTES",
    category: "Modular - Inferior",
    thumbnail: "/models/novos/modular/INFERIOR/329.webp",
    createdAt: "16-05-2026",
    path: "modular/INFERIOR/329",
    custom: false,
    wiggle: false
  },
  {
    id: "330",
    name: "CALÇÃO FUTEBOL CORTE MEIO LARGO A FINO",
    category: "Modular - Inferior",
    thumbnail: "/models/novos/modular/INFERIOR/330.webp",
    createdAt: "16-05-2026",
    path: "modular/INFERIOR/330",
    custom: false,
    wiggle: false
  },
  {
    id: "331",
    name: "CALÇÃO FUTEBOL RECORTE LATERAL",
    category: "Modular - Inferior",
    thumbnail: "/models/novos/modular/INFERIOR/331.webp",
    createdAt: "16-05-2026",
    path: "modular/INFERIOR/331",
    custom: false,
    wiggle: false
  },
  {
    id: "332",
    name: "CALÇÃO RECORTE LATERAL E TRASEIRO",
    category: "Modular - Inferior",
    thumbnail: "/models/novos/modular/INFERIOR/332.webp",
    createdAt: "16-05-2026",
    path: "modular/INFERIOR/332",
    custom: false,
    wiggle: false
  },
  {
    id: "333",
    name: "MEIÃO",
    category: "Modular - Inferior",
    thumbnail: "/models/novos/modular/INFERIOR/333.webp",
    createdAt: "16-05-2026",
    path: "modular/INFERIOR/333",
    custom: false,
    wiggle: false
  },
  {
    id: "334",
    name: "CAMISA AGRO - TRADICIONAL CURTA",
    category: "Animados Novos",
    thumbnail: "/models/novos/animations/334.webp",
    createdAt: "23-05-2026",
    path: "animations/334",
    custom: false,
    wiggle: false,
  },
  {
    id: "335",
    name: "CAMISA AGRO - TRADICIONAL LONGA",
    category: "Animados Novos",
    thumbnail: "/models/novos/animations/335.webp",
    createdAt: "23-05-2026",
    path: "animations/335",
    custom: false,
    wiggle: false,
  },
  {
    id: "336",
    name: "CAMISA GOLA O - MANGA CURTA COM BARRA",
    category: "Animados Novos",
    thumbnail: "/models/novos/animations/336.webp",
    createdAt: "23-05-2026",
    path: "animations/336",
    custom: false,
    wiggle: false,
  },
  {
    id: "337",
    name: "CAMISA GOLA O - MANGA LONGA COM PUNHO",
    category: "Animados Novos",
    thumbnail: "/models/novos/animations/337.webp",
    createdAt: "23-05-2026",
    path: "animations/337",
    custom: false,
    wiggle: false,
  },
  {
    id: "338",
    name: "CAMISA GOLA V COMUM - MANGA CURTA COM BARRA",
    category: "Animados Novos",
    thumbnail: "/models/novos/animations/338.webp",
    createdAt: "23-05-2026",
    path: "animations/338",
    custom: false,
    wiggle: false,
  },
  {
    id: "339",
    name: "CAMISA GOLA V COMUM - MANGA LONGA COM PUNHO",
    category: "Animados Novos",
    thumbnail: "/models/novos/animations/339.webp",
    createdAt: "23-05-2026",
    path: "animations/339",
    custom: false,
    wiggle: false,
  },
  {
    id: "340",
    name: "AGASALHO",
    category: "Animados Novos",
    thumbnail: "/models/novos/animations/340.webp",
    createdAt: "23-05-2026",
    path: "animations/340",
    custom: false,
    wiggle: false,
  },
  {
    id: "341",
    name: "MOLETOM",
    category: "Animados Novos",
    thumbnail: "/models/novos/animations/341.webp",
    createdAt: "23-05-2026",
    path: "animations/341",
    custom: false,
    wiggle: false,
  },
  {
    id: "342",
    name: "Camiseta Básica Regular",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/342.webp",
    createdAt: "26-05-2026",
    path: "cgtrader/342",
    custom: false,
  },
  {
    id: "343",
    name: "Moletom com Zíper",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/343.webp",
    createdAt: "26-05-2026",
    path: "cgtrader/343",
    custom: false,
  },
  {
    id: "344",
    name: "Moletom",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/344.webp",
    createdAt: "26-05-2026",
    path: "cgtrader/344",
    custom: false,
  },
  {
    id: "345",
    name: "Moda Urbana 1",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/345.webp",
    createdAt: "27-05-2026",
    path: "cgtrader/345",
    custom: false,
  },
  {
    id: "346",
    name: "Moda Urbana 2",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/346.webp",
    createdAt: "27-05-2026",
    path: "cgtrader/346",
    custom: false,
  },
  {
    id: "347",
    name: "Moda Urbana 3",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/347.webp",
    createdAt: "27-05-2026",
    path: "cgtrader/347",
    custom: false,
  },
  {
    id: "348",
    name: "Moda Urbana 4",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/348.webp",
    createdAt: "27-05-2026",
    path: "cgtrader/348",
    custom: false,
  },
  {
    id: "349",
    name: "Moda Urbana 5",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/349.webp",
    createdAt: "27-05-2026",
    path: "cgtrader/349",
    custom: false,
  },
  {
    id: "350",
    name: "Camiseta de algodão",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/350.webp",
    createdAt: "02-06-2026",
    path: "cgtrader/350",
    custom: false,
  },
  {
    id: "351",
    name: "Roupa de verão",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/351.webp",
    createdAt: "02-06-2026",
    path: "cgtrader/351",
    custom: false,
  },
  {
    id: "352",
    name: "Blusa de moletom polo masculina estampada com patch",
    category: "cgtrader",
    thumbnail: "/models/novos/cgtrader/352.webp",
    createdAt: "02-06-2026",
    path: "cgtrader/352",
    custom: false,
  },
  {
    id: "353",
    name: "BLUSA CORTA VENTO COM BOLSO",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/353.webp",
    createdAt: "08-06-2026",
    path: "sisbolt_novos_mockups/353",
    custom: false,
  },
  {
    id: "354",
    name: "CAMISA ARBITRO MANGA COM PUNHO",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/354.webp",
    createdAt: "08-06-2026",
    path: "sisbolt_novos_mockups/354",
    custom: false,
  },
  {
    id: "355",
    name: "CAMISA ARBITRO MANGA COM PUNHO ENSACADA",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/355.webp",
    createdAt: "08-06-2026",
    path: "sisbolt_novos_mockups/355",
    custom: false,
  },
  {
    id: "356",
    name: "CAMISA ARBITRO MANGA SEM PUNHO",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/356.webp",
    createdAt: "08-06-2026",
    path: "sisbolt_novos_mockups/356",
    custom: false,
  },
  {
    id: "357",
    name: "CAMISA ARBITRO MANGA SEM PUNHO ENSACADA",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/357.webp",
    createdAt: "08-06-2026",
    path: "sisbolt_novos_mockups/357",
    custom: false,
  },
  {
    id: "358",
    name: "CAMISA GOLA BACANA - MANGA CURTA COM PUNHO",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/358.webp",
    createdAt: "08-06-2026",
    path: "sisbolt_novos_mockups/358",
    custom: false,
  },
  {
    id: "359",
    name: "CAMISA GOLA BACANA - MANGA CURTA SEM PUNHO",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/359.webp",
    createdAt: "08-06-2026",
    path: "sisbolt_novos_mockups/359",
    custom: false,
  },
  {
    id: "360",
    name: "BLUSA CORTA VENTO SEM BOLSO",
    category: "sisbolt_novos_mockups",
    thumbnail: "/models/novos/sisbolt_novos_mockups/360.webp",
    createdAt: "08-06-2026",
    path: "sisbolt_novos_mockups/360",
    custom: false,
  },
  {
    id: "361",
    name: "CAMISA GOLA PADRE - MANGA CURTA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/361.webp",
    createdAt: "13-07-2026",
    path: "golas/361",
    custom: false,
  },
  {
    id: "362",
    name: "CAMISA GOLA PADRE - MANGA CURTA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/362.webp",
    createdAt: "13-07-2026",
    path: "golas/362",
    custom: false,
  },
  {
    id: "363",
    name: "CAMISA GOLA PADRE - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/363.webp",
    createdAt: "13-07-2026",
    path: "golas/363",
    custom: false,
  },
  {
    id: "364",
    name: "CAMISA GOLA PADRE - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/364.webp",
    createdAt: "13-07-2026",
    path: "golas/364",
    custom: false,
  },
  {
    id: "365",
    name: "CAMISA GOLA POLO - MANGA CURTA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/365.webp",
    createdAt: "13-07-2026",
    path: "golas/365",
    custom: false,
  },
  {
    id: "366",
    name: "CAMISA GOLA POLO - MANGA CURTA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/366.webp",
    createdAt: "13-07-2026",
    path: "golas/366",
    custom: false,
  },
  {
    id: "367",
    name: "CAMISA GOLA POLO - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/367.webp",
    createdAt: "13-07-2026",
    path: "golas/367",
    custom: false,
  },
  {
    id: "368",
    name: "CAMISA GOLA POLO - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/368.webp",
    createdAt: "13-07-2026",
    path: "golas/368",
    custom: false,
  },
  {
    id: "369",
    name: "CAMISA GOLA REDONDA - MANGA CURTA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/369.webp",
    createdAt: "13-07-2026",
    path: "golas/369",
    custom: false,
  },
  {
    id: "370",
    name: "CAMISA GOLA REDONDA - MANGA CURTA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/370.webp",
    createdAt: "13-07-2026",
    path: "golas/370",
    custom: false,
  },
  {
    id: "371",
    name: "CAMISA GOLA REDONDA - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/371.webp",
    createdAt: "13-07-2026",
    path: "golas/371",
    custom: false,
  },
  {
    id: "372",
    name: "CAMISA GOLA REDONDA - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/372.webp",
    createdAt: "13-07-2026",
    path: "golas/372",
    custom: false,
  },
  {
    id: "373",
    name: "CAMISA GOLA V - MANGA CURTA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/373.webp",
    createdAt: "13-07-2026",
    path: "golas/373",
    custom: false,
  },
  {
    id: "374",
    name: "CAMISA GOLA V - MANGA CURTA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/374.webp",
    createdAt: "13-07-2026",
    path: "golas/374",
    custom: false,
  },
  {
    id: "375",
    name: "CAMISA GOLA V - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/375.webp",
    createdAt: "13-07-2026",
    path: "golas/375",
    custom: false,
  },
  {
    id: "376",
    name: "CAMISA GOLA V - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/376.webp",
    createdAt: "13-07-2026",
    path: "golas/376",
    custom: false,
  },
  {
    id: "377",
    name: "CAMISA GOLA V2 - MANGA CURTA COM BARRA",
    category: "golas",
    thumbnail: "/models/novos/golas/377.webp",
    createdAt: "13-07-2026",
    path: "golas/377",
    custom: false,
  },
  {
    id: "378",
    name: "RAGLAN GOLA PADRE - MANGA CURTA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/378.webp",
    createdAt: "13-07-2026",
    path: "golas/378",
    custom: false,
  },
  {
    id: "379",
    name: "RAGLAN GOLA POLO - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/379.webp",
    createdAt: "13-07-2026",
    path: "golas/379",
    custom: false,
  },
  {
    id: "380",
    name: "CAMISA GOLA V2 - MANGA CURTA NORMAL",
    category: "golas",
    thumbnail: "/models/novos/golas/380.webp",
    createdAt: "13-07-2026",
    path: "golas/380",
    custom: false,
  },
  {
    id: "381",
    name: "CAMISA GOLA V2 - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/381.webp",
    createdAt: "13-07-2026",
    path: "golas/381",
    custom: false,
  },
  {
    id: "382",
    name: "CAMISA GOLA V2 - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/382.webp",
    createdAt: "13-07-2026",
    path: "golas/382",
    custom: false,
  },
  {
    id: "383",
    name: "CAMISA GOLA V3 - MANGA CURTA COM BARRA",
    category: "golas",
    thumbnail: "/models/novos/golas/383.webp",
    createdAt: "13-07-2026",
    path: "golas/383",
    custom: false,
  },
  {
    id: "384",
    name: "CAMISA GOLA V3 - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/384.webp",
    createdAt: "13-07-2026",
    path: "golas/384",
    custom: false,
  },
  {
    id: "385",
    name: "RAGLAN GOLA O - MANGA CURTA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/385.webp",
    createdAt: "13-07-2026",
    path: "golas/385",
    custom: false,
  },
  {
    id: "386",
    name: "RAGLAN GOLA O - MANGA CURTA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/386.webp",
    createdAt: "13-07-2026",
    path: "golas/386",
    custom: false,
  },
  {
    id: "387",
    name: "RAGLAN GOLA O - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/387.webp",
    createdAt: "13-07-2026",
    path: "golas/387",
    custom: false,
  },
  {
    id: "388",
    name: "RAGLAN GOLA O - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/388.webp",
    createdAt: "13-07-2026",
    path: "golas/388",
    custom: false,
  },
  {
    id: "389",
    name: "RAGLAN GOLA PADRE - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/389.webp",
    createdAt: "13-07-2026",
    path: "golas/389",
    custom: false,
  },
  {
    id: "390",
    name: "RAGLAN GOLA PADRE - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/390.webp",
    createdAt: "13-07-2026",
    path: "golas/390",
    custom: false,
  },
  {
    id: "391",
    name: "RAGLAN GOLA POLO - MANGA CURTA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/391.webp",
    createdAt: "13-07-2026",
    path: "golas/391",
    custom: false,
  },
  {
    id: "392",
    name: "RAGLAN GOLA POLO - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/392.webp",
    createdAt: "13-07-2026",
    path: "golas/392",
    custom: false,
  },
  {
    id: "393",
    name: "RAGLAN GOLA V - MANGA CURTA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/393.webp",
    createdAt: "13-07-2026",
    path: "golas/393",
    custom: false,
  },
  {
    id: "394",
    name: "RAGLAN GOLA V - MANGA CURTA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/394.webp",
    createdAt: "13-07-2026",
    path: "golas/394",
    custom: false,
  },
  {
    id: "395",
    name: "RAGLAN GOLA V - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/395.webp",
    createdAt: "13-07-2026",
    path: "golas/395",
    custom: false,
  },
  {
    id: "396",
    name: "RAGLAN GOLA V - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/396.webp",
    createdAt: "13-07-2026",
    path: "golas/396",
    custom: false,
  },
  {
    id: "397",
    name: "RAGLAN GOLA V2 - MANGA CURTA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/397.webp",
    createdAt: "13-07-2026",
    path: "golas/397",
    custom: false,
  },
  {
    id: "398",
    name: "RAGLAN GOLA V2 - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/398.webp",
    createdAt: "13-07-2026",
    path: "golas/398",
    custom: false,
  },
  {
    id: "399",
    name: "RAGLAN GOLA V3 - MANGA CURTA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/399.webp",
    createdAt: "13-07-2026",
    path: "golas/399",
    custom: false,
  },
  {
    id: "400",
    name: "RAGLAN GOLA V3 - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/400.webp",
    createdAt: "13-07-2026",
    path: "golas/400",
    custom: false,
  },
  {
    id: "401",
    name: "CAMISA GOLA V3 - MANGA CURTA NORMAL",
    category: "golas",
    thumbnail: "/models/novos/golas/401.webp",
    createdAt: "13-07-2026",
    path: "golas/401",
    custom: false,
  },
  {
    id: "402",
    name: "CAMISA GOLA V3 - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/402.webp",
    createdAt: "13-07-2026",
    path: "golas/402",
    custom: false,
  },
  {
    id: "403",
    name: "RAGLAN GOLA PADRE - MANGA CURTA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/403.webp",
    createdAt: "13-07-2026",
    path: "golas/403",
    custom: false,
  },
  {
    id: "404",
    name: "RAGLAN GOLA POLO - MANGA CURTA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/404.webp",
    createdAt: "13-07-2026",
    path: "golas/404",
    custom: false,
  },
  {
    id: "405",
    name: "RAGLAN GOLA V2 - MANGA CURTA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/405.webp",
    createdAt: "13-07-2026",
    path: "golas/405",
    custom: false,
  },
  {
    id: "406",
    name: "RAGLAN GOLA V2 - MANGA LONGA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/406.webp",
    createdAt: "13-07-2026",
    path: "golas/406",
    custom: false,
  },
  {
    id: "407",
    name: "RAGLAN GOLA V3 - MANGA CURTA COM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/407.webp",
    createdAt: "13-07-2026",
    path: "golas/407",
    custom: false,
  },
  {
    id: "408",
    name: "RAGLAN GOLA V3 - MANGA LONGA SEM PUNHO",
    category: "golas",
    thumbnail: "/models/novos/golas/408.webp",
    createdAt: "13-07-2026",
    path: "golas/408",
    custom: false,
  },
  {
    id: "409",
    name: "AGASALHO",
    category: "golas",
    thumbnail: "/models/novos/golas/409.webp",
    createdAt: "13-07-2026",
    path: "golas/409",
    custom: false,
  },
  {
    id: "410",
    name: "CAMISA RAGLAN GOLA O MANGA CURTA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/410.webp",
    createdAt: "17-07-2026",
    path: "feminino/410",
    custom: false,
  },
  {
    id: "411",
    name: "CAMISA RAGLAN GOLA V MANGA CURTA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/411.webp",
    createdAt: "17-07-2026",
    path: "feminino/411",
    custom: false,
  },
  {
    id: "412",
    name: "CAMISA BABY LOOK GOLA O COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/412.webp",
    createdAt: "17-07-2026",
    path: "feminino/412",
    custom: false,
  },
  {
    id: "413",
    name: "CAMISA BABY LOOK GOLA O MANGA LONGA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/413.webp",
    createdAt: "17-07-2026",
    path: "feminino/413",
    custom: false,
  },
  {
    id: "414",
    name: "CAMISA BABY LOOK GOLA O MANGA LONGA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/414.webp",
    createdAt: "17-07-2026",
    path: "feminino/414",
    custom: false,
  },
  {
    id: "415",
    name: "CAMISA BABY LOOK GOLA O SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/415.webp",
    createdAt: "17-07-2026",
    path: "feminino/415",
    custom: false,
  },
  {
    id: "416",
    name: "CAMISA BABY LOOK GOLA V AFINADA MANGA CURTA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/416.webp",
    createdAt: "17-07-2026",
    path: "feminino/416",
    custom: false,
  },
  {
    id: "417",
    name: "CAMISA BABY LOOK GOLA V AFINADA MANGA CURTA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/417.webp",
    createdAt: "17-07-2026",
    path: "feminino/417",
    custom: false,
  },
  {
    id: "418",
    name: "CAMISA BABY LOOK GOLA V AFINADA MANGA LONGA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/418.webp",
    createdAt: "17-07-2026",
    path: "feminino/418",
    custom: false,
  },
  {
    id: "419",
    name: "CAMISA BABY LOOK GOLA V COMUM MANGA CURTA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/419.webp",
    createdAt: "17-07-2026",
    path: "feminino/419",
    custom: false,
  },
  {
    id: "420",
    name: "CAMISA BABY LOOK GOLA V COMUM MANGA CURTA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/420.webp",
    createdAt: "17-07-2026",
    path: "feminino/420",
    custom: false,
  },
  {
    id: "421",
    name: "CAMISA BABY LOOK GOLA V COMUM MANGA LONGA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/421.webp",
    createdAt: "17-07-2026",
    path: "feminino/421",
    custom: false,
  },
  {
    id: "422",
    name: "CAMISA BABY LOOK GOLA V COMUM MANGA LONGA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/422.webp",
    createdAt: "17-07-2026",
    path: "feminino/422",
    custom: false,
  },
  {
    id: "423",
    name: "CAMISA BABY LOOK GOLA V SEM FIM MANGA CURTA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/423.webp",
    createdAt: "17-07-2026",
    path: "feminino/423",
    custom: false,
  },
  {
    id: "424",
    name: "CAMISA BABY LOOK GOLA V SEM FIM MANGA CURTA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/424.webp",
    createdAt: "17-07-2026",
    path: "feminino/424",
    custom: false,
  },
  {
    id: "425",
    name: "CAMISA BABY LOOK GOLA V SEM FIM MANGA LONGA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/425.webp",
    createdAt: "17-07-2026",
    path: "feminino/425",
    custom: false,
  },
  {
    id: "426",
    name: "CAMISA BABY LOOK GOLA V SEM FIM MANGA LONGA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/426.webp",
    createdAt: "17-07-2026",
    path: "feminino/426",
    custom: false,
  },
  {
    id: "427",
    name: "CAMISA BABY LOOK GOLA V SOBREPOSTA MANGA CURTA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/427.webp",
    createdAt: "17-07-2026",
    path: "feminino/427",
    custom: false,
  },
  {
    id: "428",
    name: "CAMISA BABY LOOK GOLA V SOBREPOSTA MANGA CURTA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/428.webp",
    createdAt: "17-07-2026",
    path: "feminino/428",
    custom: false,
  },
  {
    id: "429",
    name: "CAMISA BABY LOOK GOLA V SOBREPOSTA MANGA LONGA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/429.webp",
    createdAt: "17-07-2026",
    path: "feminino/429",
    custom: false,
  },
  {
    id: "430",
    name: "CAMISA BABY LOOK GOLA V SOBREPOSTA MANGA LONGA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/430.webp",
    createdAt: "17-07-2026",
    path: "feminino/430",
    custom: false,
  },
  {
    id: "431",
    name: "CAMISA BABY LOOK GOLA V TRANSPASSADA MANGA CURTA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/431.webp",
    createdAt: "17-07-2026",
    path: "feminino/431",
    custom: false,
  },
  {
    id: "432",
    name: "CAMISA BABY LOOK GOLA V TRANSPASSADA MANGA CURTA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/432.webp",
    createdAt: "17-07-2026",
    path: "feminino/432",
    custom: false,
  },
  {
    id: "433",
    name: "CAMISA BABY LOOK GOLA V TRANSPASSADA MANGA LONGA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/433.webp",
    createdAt: "17-07-2026",
    path: "feminino/433",
    custom: false,
  },
  {
    id: "434",
    name: "CAMISA BABY LOOK GOLA V TRANSPASSADA MANGA LONGA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/434.webp",
    createdAt: "17-07-2026",
    path: "feminino/434",
    custom: false,
  },
  {
    id: "435",
    name: "CAMISA RAGLAN GOLA O MANGA CURTA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/435.webp",
    createdAt: "17-07-2026",
    path: "feminino/435",
    custom: false,
  },
  {
    id: "436",
    name: "CAMISA RAGLAN GOLA O MANGA LONGA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/436.webp",
    createdAt: "17-07-2026",
    path: "feminino/436",
    custom: false,
  },
  {
    id: "437",
    name: "CAMISA RAGLAN GOLA O MANGA LONGA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/437.webp",
    createdAt: "17-07-2026",
    path: "feminino/437",
    custom: false,
  },
  {
    id: "438",
    name: "CAMISA RAGLAN GOLA V MANGA CURTA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/438.webp",
    createdAt: "17-07-2026",
    path: "feminino/438",
    custom: false,
  },
  {
    id: "439",
    name: "CAMISA RAGLAN GOLA V MANGA LONGA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/439.webp",
    createdAt: "17-07-2026",
    path: "feminino/439",
    custom: false,
  },
  {
    id: "440",
    name: "CAMISA RAGLAN GOLA V MANGA LONGA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/440.webp",
    createdAt: "17-07-2026",
    path: "feminino/440",
    custom: false,
  },
  {
    id: "441",
    name: "MOLETOM COM BOLSO E ZIPER E CAPUZ",
    category: "feminino",
    thumbnail: "/models/novos/feminino/441.webp",
    createdAt: "17-07-2026",
    path: "feminino/441",
    custom: false,
  },
  {
    id: "442",
    name: "MOLETOM COM BOLSO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/442.webp",
    createdAt: "17-07-2026",
    path: "feminino/442",
    custom: false,
  },
  {
    id: "443",
    name: "MOLETOM SEM BOLSO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/443.webp",
    createdAt: "17-07-2026",
    path: "feminino/443",
    custom: false,
  },
  {
    id: "444",
    name: "SHORT SAIA MONTARIA",
    category: "feminino",
    thumbnail: "/models/novos/feminino/444.webp",
    createdAt: "17-07-2026",
    path: "feminino/444",
    custom: false,
  },
  {
    id: "445",
    name: "SHORT GINASTICA 2 PARTES",
    category: "feminino",
    thumbnail: "/models/novos/feminino/445.webp",
    createdAt: "17-07-2026",
    path: "feminino/445",
    custom: false,
  },
  {
    id: "446",
    name: "SHORT FUTVOLEI CAVADO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/446.webp",
    createdAt: "17-07-2026",
    path: "feminino/446",
    custom: false,
  },
  {
    id: "447",
    name: "CALÇAO FUTEBOL TRADICIONAL",
    category: "feminino",
    thumbnail: "/models/novos/feminino/447.webp",
    createdAt: "17-07-2026",
    path: "feminino/447",
    custom: false,
  },
  {
    id: "448",
    name: "CALÇAO FUTEBOL RECORTE TRASEIRO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/448.webp",
    createdAt: "17-07-2026",
    path: "feminino/448",
    custom: false,
  },
   {
    id: "449",
    name: "CALÇAO FUTEBOL CORTE LATERAL",
    category: "feminino",
    thumbnail: "/models/novos/feminino/449.webp",
    createdAt: "17-07-2026",
    path: "feminino/449",
    custom: false,
  },
  {
    id: "450",
    name: "CALÇAO FUTEBOL 2 PARTES",
    category: "feminino",
    thumbnail: "/models/novos/feminino/450.webp",
    createdAt: "17-07-2026",
    path: "feminino/450",
    custom: false,
  },
  {
    id: "451",
    name: "CALÇAO BEACH TENIS 4 PARTES",
    category: "feminino",
    thumbnail: "/models/novos/feminino/451.webp",
    createdAt: "17-07-2026",
    path: "feminino/451",
    custom: false,
  },
  {
    id: "452",
    name: "CALÇA FEMININA SEM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/452.webp",
    createdAt: "17-07-2026",
    path: "feminino/452",
    custom: false,
  },
  {
    id: "453",
    name: "CALÇA FEMININA COM PUNHO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/453.webp",
    createdAt: "17-07-2026",
    path: "feminino/453",
    custom: false,
  },
  {
    id: "454",
    name: "MEIÃO",
    category: "feminino",
    thumbnail: "/models/novos/feminino/454.webp",
    createdAt: "17-07-2026",
    path: "feminino/454",
    custom: false,
  },
  {
    id: "455",
    name: "Camisa Tradicional",
    category: "bases_novas_física",
    thumbnail: "/models/novos/bases_novas/455.webp",
    createdAt: "14-08-2026",
    path: "bases_novas/455",
    custom: false,
    wiggle: false
  },
];
export { sampleProjects };
